var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeWidth":"2.5","transform":"translate(2 2)"},[React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M4.706 7l2.867 3 2.867-3","key":0}),React.createElement("circle",{"cx":"8","cy":"8","r":"8","key":1})]));
}

CheckCircle.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
